import { SwatchesState } from './swatches.types'

export const state: SwatchesState = {
  swatches: [],
  swatchesLoadingError: null
}
